import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/useToast';
import { useI18n } from '@/hooks/useI18n';

export const useGoogleAuth = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useI18n();

  const signInWithGoogle = async (role?: string) => {
    setIsLoading(true);

    if (role) {
      sessionStorage.setItem('p2b_google_signup', JSON.stringify({ role, ts: Date.now() }));
    }

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin
      },
    });

    if (error) {
      console.error('Error signing in with Google:', error);
      toast({
        title: t('auth.googleErrorTitle'),
        description: t('auth.googleErrorDesc'),
        variant: "destructive",
      });
    }

    setIsLoading(false);
    return { error };

  };

  return {
    signInWithGoogle,
    isLoading,
  };
}; 